<template>
  <AuxiliaryList
    :items="contactLensTestLayouts"
    typeName="desenho"
    :deleteMutation="deleteItem"
    :saveMutation="save"
    :refreshList="refreshList"
  />
</template>

<script>
  import AuxiliaryList from "@/components/config/contact_len/auxiliary/list.vue";

  export default {
    name: "ContactLenLayoutConfig",

    components: {
      AuxiliaryList,
    },
    apollo: {
      contactLensTestLayouts: {
        query: require("@/graphql/contact_lens_test/layouts.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      deleteItem({ id }) {
        return this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/delete_contact_lens_layout.gql"),
          variables: {
            contactLensLayoutId: id,
          },
        });
      },
      save({ id, name }) {
        return this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/save_contact_lens_layout.gql"),
          variables: {
            contactLensLayoutId: id,
            name: name,
          },
        });
      },
      refreshList() {
        return this.$apollo.queries.contactLensTestLayouts.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
